import { setVisitedFeature, VStack, colors, HStack } from "goi_common";
import { useEffect, useMemo } from "react";
import ParlorRegionBreadcrumb from "./ParlorRegionBreadcrumb";
import { Box } from "@chakra-ui/react";
import TabInfoSection from "./components/TabInfoSection";

import { ParlorDetailProps } from "@/types/parlor";
import HiddenSeoWrapper from "@/components/HiddenSeoWrapper";
import ParlorServiceSummary from "./components/ParlorServiceSummary";
import ParlorListTabPanel from "./components/TabInfoSection/ParlorListTabPanel";
import RichSearch from "@/components/common/RichSearch";
import { richSearchData } from "@/constants/richSearch";
import SigunguSelector from "@/components/common/SigunguSelector";
import { ParlorDetailUvGuidebookBanner } from "../ParlorDetailContainer/components/TabInfoSection/PriceInfoTabPanel/ParlorDetailUvGuidebookBanner";
import HomeRequestBox from "@/containers/HomeContainer/components/RenewalVersion/HomeRequestBox";

function ParlorRegionContainer(props: {
  sido: string;
  sidoName: string;
  sigungu?: string;
  sigunguName?: string;
  isSigungu: boolean;
  regionParlors: Array<ParlorDetailProps>;
  hasSigunguParlor: boolean;
}) {
  const { sido, sidoName, sigungu, sigunguName, regionParlors, hasSigunguParlor, isSigungu } =
    props;

  const { carouselRichSearch, reviewRichSearch } = richSearchData.funeral;

  useEffect(() => {
    setVisitedFeature("parlor-region");
  }, []);

  const name = useMemo(() => {
    if (sigunguName) {
      return `${sigunguName} 장례식장`;
    } else {
      return `${sidoName} 장례식장`;
    }
  }, [sidoName, sigunguName]);

  const expectedParlorPrice = useMemo(() => {
    return (
      regionParlors.reduce((prev, curr) => {
        return curr.expected_charge_sum["가족장"] + prev;
      }, 0) / regionParlors.length
    );
  }, [regionParlors, sigungu, sido]);

  const getRegionParlorCount = () => {
    if (isSigungu && !hasSigunguParlor) {
      return 0;
    }

    return regionParlors.length;
  };

  const regionParlorCount = getRegionParlorCount();

  return (
    <VStack width="100%" alignItems="center">
      <RichSearch data={carouselRichSearch(regionParlors)} />
      <RichSearch data={reviewRichSearch} />
      <VStack width="100%" maxWidth="480px">
        <VStack padding="18px 24px 0" gap="2px">
          <ParlorRegionBreadcrumb
            path="parlor_region"
            sidoName={sidoName}
            sigunguName={sigunguName}
          />
          <HStack justifyContent="space-between">
            <VStack position="relative">
              <Box as="h1" className="subtitle_21_b" wordBreak="keep-all">
                {name} 추천
              </Box>
              <Box as="h2" className="subtitle_16_b gray500" wordBreak="keep-all">
                <span className="orange650">{regionParlorCount}개</span>의 장례식장이 있어요
              </Box>
              <HiddenSeoWrapper>
                {name}은 총 {regionParlorCount}개의 장례식장을 추천드려요.
              </HiddenSeoWrapper>
            </VStack>

            <VStack>
              <SigunguSelector sido={sido} sidoName={sidoName} sigunguName={sigunguName} />
            </VStack>
          </HStack>
        </VStack>
        <HiddenSeoWrapper>
          <VStack background={colors.warmGray100}>
            <Box
              as="h2"
              padding="18px 24px 0"
              className="subtitle_18_b"
              aria-label={name + " 추천 리스트"}
            >
              {name} 추천 리스트
            </Box>
            <HiddenSeoWrapper>{name}의 장례식장 추천 리스트 입니다.</HiddenSeoWrapper>
            <ParlorListTabPanel
              name={name}
              parlors={regionParlors}
              sido={sido}
              sigungu={sigungu}
              expectedParlorPrice={regionParlors.length === 0 ? 3700000 : expectedParlorPrice}
            />
          </VStack>
        </HiddenSeoWrapper>
        <ParlorServiceSummary
          parlors={regionParlors}
          type={"전체"}
          name={name}
          sidoName={sidoName}
          sido={sido}
          sigunguName={sigunguName}
          hasSigunguParlor={hasSigunguParlor}
          isSigungu={isSigungu}
        />

        <VStack
          width="100%"
          alignItems="center"
          // background={`url(${getCdnImageSrc("platform/home/home_hero_back.png")})`}
          backgroundSize="cover"
          backgroundPosition="center"
          padding="15px 0px"
        >
          <VStack maxWidth="480px" width="100%" justifyContent="center">
            {/* <VStack css={{ color: "white" }} margin={"0px 18px 32px"}>
              <div className={"subtitle_21_sb"}>사용한 만큼만 내고 추가구매 유도없는</div>
              <div className={"head_24_b"}>합리적인 맞춤형 장례, 고이</div>
            </VStack> */}

            <VStack maxWidth="480px" width="100%" padding="0 16px">
              <HomeRequestBox path="parlor_region" position="top" hasSocialProof />
            </VStack>
          </VStack>
        </VStack>

        <VStack padding="20px 0 40px 0">
          <ParlorDetailUvGuidebookBanner
            backgroundImageSrc="platform/guidebook/prepare-image.png"
            href="/guidebook/tip/before/4?utm_source=platform&utm_medium=parlor_region"
            topNode=""
            bottomNode="장례식장 vs 상조회사 나에게 맞는 곳은?"
            event={{
              newGtm: {
                path: "parlor_region",
                trigger_and_target: "content-uv_gdb_tip_before_4",
              },
            }}
          />
        </VStack>

        <TabInfoSection
          expectedParlorPrice={expectedParlorPrice}
          parlors={regionParlors}
          name={name}
          sidoName={sidoName}
          sido={sido}
          sigunguName={sigunguName}
          sigungu={sigungu}
        />
      </VStack>
    </VStack>
  );
}
export default ParlorRegionContainer;
